import { useState } from 'react';
import { Button, Stack, Snackbar, Alert } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { approvalsApi, type PendingApproval } from '../../api/engine.api';
import { extractApiError } from '../../api/error';

export function MyApprovalsPage() {
  const qc = useQueryClient();
  const [toast, setToast] = useState<string | null>(null);
  const { data, isLoading } = useQuery({ queryKey: ['my-approvals'], queryFn: approvalsApi.pending });
  const refresh = () => { qc.invalidateQueries({ queryKey: ['my-approvals'] }); qc.invalidateQueries({ queryKey: ['notif-unread'] }); };

  const act = useMutation({
    mutationFn: ({ stepId, decision }: { stepId: number; decision: 'approve' | 'reject' }) => approvalsApi.act(stepId, decision),
    onSuccess: refresh,
    onError: (e) => setToast(extractApiError(e)),
  });

  const columns: Column<PendingApproval>[] = [
    { key: 'moduleName', label: 'Module' },
    { key: 'title', label: 'Title' },
    { key: 'amount', label: 'Amount', align: 'right', render: (r) => `₹${r.amount.toLocaleString()}` },
    { key: 'level', label: 'Level', width: 80 },
    { key: 'approverRole', label: 'As Role' },
    { key: 'dueAt', label: 'Due', render: (r) => (r.dueAt ? new Date(r.dueAt).toLocaleDateString() : '—') },
  ];

  return (
    <>
      <PageHeader title="My Approvals" subtitle="Items awaiting your decision at the current approval level." />
      <DataTable
        columns={columns} rows={data ?? []} loading={isLoading}
        page={1} limit={data?.length || 25} total={data?.length ?? 0} onPageChange={() => undefined} onLimitChange={() => undefined} rowKey={(r) => r.stepId}
        emptyTitle="No pending approvals" emptyDescription="You're all caught up."
        actions={(r) => (
          <Stack direction="row" spacing={1}>
            <Button size="small" color="success" variant="outlined" onClick={() => act.mutate({ stepId: r.stepId, decision: 'approve' })}>Approve</Button>
            <Button size="small" color="error" variant="outlined" onClick={() => act.mutate({ stepId: r.stepId, decision: 'reject' })}>Reject</Button>
          </Stack>
        )}
      />
      <Snackbar open={Boolean(toast)} autoHideDuration={6000} onClose={() => setToast(null)}><Alert severity="warning" onClose={() => setToast(null)}>{toast}</Alert></Snackbar>
    </>
  );
}
